import { LOGO_VIEW_BOX, MARK_PATHS, WORDMARK_PATHS } from './xendrel-geometry'

const LOGO_PATHS = [...MARK_PATHS, ...WORDMARK_PATHS]

/**
 * Xendrel lockup — the mark with the XENDREL wordmark, spaced as in the brand file.
 *
 * Size it by height (`h-*`); the width follows. Fills with `currentColor`, so it
 * follows the app theme; an `<img>` of `public/xendrel-logo.svg` can only follow
 * the OS one.
 */
export function XendrelLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox={LOGO_VIEW_BOX}
      className={className}
      fill="currentColor"
      role="img"
      aria-label="Xendrel"
    >
      {LOGO_PATHS.map(d => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}
